import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import Calendar from 'react-calendar';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
// import "../../css/yemae.css";
// import "react-date-picker/dist/DatePicker.css";
// import "react-calendar/dist/Calendar.css";
import '../css/calendar.css';
import axios from 'axios';
import moment from 'moment';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { Modal } from 'react-responsive-modal';
import { isMobile } from 'react-device-detect';
import '../css/media_m.css';

const initState = {
  rdate: '0',
  rtime: '0',
  rtimeName: '',
  rlocation: '0',
  rcount: '0',
  payType: '',
  remainNum: 90,
};

const Reserve = (props) => {
  // console.log(props);
  const { nicName, icon, apiUrl, loginId, setQuickMenu, history, imgUrl } =
    props;
  const [value, setValue] = useState(new Date());
  const [calShow, setCalShow] = useState(false);
  const [state, setState] = useState(initState);
  const [exhibitionInfo, setExhibitionInfo] = useState([]);
  const [timetable, setTimetable] = useState([]);

  const _getData = async () => {
    const result = await axios.get(apiUrl + '/exhibitionInfo');
    const intReturn = result.data[0].intReturn;
    const data = result.data[0].listData;
    console.log(result);
    if (intReturn === 0) {
      setExhibitionInfo(data);
      _getTimetable(data[0].exhibitionCode, value);
    }
  };

  const _selectTime = (rtime, remainNum, rtimeName) => {
    console.log(rtime, remainNum);
    setState({
      ...state,
      rtime: rtime.toString(),
      rtimeName: rtimeName,
      rlocation: 1,
      rcount: '0',
      payType: '',
      remainNum: remainNum,
    });
  };

  const _selectNum = (rcount) => {
    if (rcount > state.remainNum) {
      toast.error('남은 수량을 초과했습니다.');
    }
    setState({
      ...state,
      rcount: rcount,
      payType: '',
    });

    _chkSale(rcount);
  };

  const _selectPay = (payType) => {
    setState({
      ...state,
      payType: payType,
    });
  };

  const _onChange = (e) => {
    if (e.target.name === 'rtime') {
      setState({
        ...state,
        rtime: e.target.value,
        rlocation: '0',
        rcount: '0',
        payType: '',
      });
    }
    if (e.target.name === 'rlocation') {
      setState({
        ...state,
        rlocation: e.target.value,
        rcount: '0',
        payType: '',
      });
    }

    if (e.target.name === 'rcount') {
      setState({
        ...state,
        rcount: e.target.value,
        payType: '',
      });
      _chkSale(e.target.value);
    }
    if (e.target.name === 'payType') {
      setState({
        ...state,
        payType: e.target.value,
      });
    }
  };

  const _chkSale = async (rcount) => {
    const { rdate, rtime, rlocation } = state;
    const result = await axios.post(apiUrl + '/exhibitionChkSale', {
      rdate,
      rtime,
      rlocation,
      rcount,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
    } else {
      alert('예매가능 수량을 초과하였습니다.');
      setState({
        ...state,
        rcount: '0',
      });
    }
  };

  const _onDateClick = (value, event) => {
    const rvalue = moment(value).format('YYYYMMDD');
    if (rvalue === '20240101' || rvalue === 20240101) {
      toast.error('2024년 1월 1일은 휴무일로 예매가 불가합니다.');
      return;
    }
    setState({
      ...state,
      rdate: rvalue,
      rtime: '0',
      rtimeName: '',
      rlocation: '0',
      rcount: '0',
      payType: '',
    });
    // setCalShow(false);
  };

  const _apply = async () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    if (loginId !== 'admin') {
      if (today < '2023-11-21 10:00:00') {
        toast.warn('예매가 시작전입니다.');
        return;
      }

      if (today > '2024-01-07 18:00:00') {
        toast.warn('예매가 종료되었습니다.');
        return;
      }
    }

    if (loginId === null || loginId === undefined || loginId === '') {
      // Swal.fire({
      //   title: 'Error!',
      //   text: '로그인 후 예매가 가능합니다',
      //   // icon: 'error',
      //   confirmButtonText: 'Cool',
      // });
      // Swal.fire('SweetAlert2 is working!');
      // alert('로그인 후 예매가 가능합니다.');
      toast.warn('로그인 후 예매가 가능합니다.');
      return false;
    }
    if (state.rdate === '0') {
      toast.warn('예매 일자를 선택하세요');
      // alert('예매 일자를 선택하세요');
      return false;
    }
    if (state.rtime === '0') {
      toast.warn('예매 회차를 선택하세요');
      // alert('예매 회차를 선택하세요');
      return false;
    }
    if (state.rlocation === '0') {
      toast.warn('상영장소를 선택하세요');
      // alert('예매 장소를 선택하세요');
      return false;
    }
    if (state.rcount === '0') {
      toast.warn('예매 수를 선택하세요');
      // alert('예매 수를 선택하세요');
      return false;
    }
    if (state.payType === '') {
      toast.warn('결제 방법을 선택하세요.');
      // alert('결제수단을 선택하세요.');
      return false;
    }

    // const { rdate, rtime, rlocation, rcount } = state;
    // const price = rcount * exhibitionInfo[0].price;
    _pay();
  };

  const _pay = async () => {
    // const cKey = 'test_ck_qLlDJaYngrooqgwBpNmrezGdRpXx';
    const cKey = 'live_ck_d26DlbXAaV0P42ERJN0VqY50Q9RB';
    const { rdate, rtime, rlocation, rcount, payType } = state;
    const amount = rcount * exhibitionInfo[0].price;
    const exhibitionCode = exhibitionInfo[0].exhibitionCode;
    const startDate = exhibitionInfo[0].startDate;
    const endDate = exhibitionInfo[0].endDate;
    const limitNum = exhibitionInfo[0].limitNum;

    const orderId = _makeOrderCode();
    const toasspayments = await loadTossPayments(cKey);
    const orderName =
      exhibitionInfo[0].exhibitionName + ' ' + rcount + '건 예매';
    // console.log(orderId);

    const result = await axios.post(apiUrl + '/exhibitionPayPre', {
      exhibitionCode,
      rdate,
      rtime,
      rlocation,
      rcount,
      orderId,
      loginId,
      amount,
      payType,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      if (
        payType === '네이버페이' ||
        payType === '카카오페이' ||
        payType === '토스페이'
      ) {
        await toasspayments.requestPayment('간편결제', {
          amount: amount,
          orderId: orderId,
          orderName: orderName,
          customerName: loginId,
          successUrl: `${window.location.origin}/tsucc`,
          failUrl: `${window.location.origin}/tfail`,
          flowMode: 'DIRECT',
          easyPay: payType,
        });
      } else {
        await toasspayments.requestPayment(payType, {
          amount: amount,
          orderId: orderId,
          orderName: orderName,
          customerName: loginId,
          successUrl: `${window.location.origin}/tsucc`,
          failUrl: `${window.location.origin}/tfail`,
          // variantKey: "DEFAULT",
        });
      }
    } else if (intReturn === -1) {
      /*주문번호 중복*/
      // alert("중복된 결제 정보입니다.");
      toast.error('중복된 결제 정보입니다.');
    } else if (intReturn === -2) {
      /*회차별 인원제한 */
      toast.error('회차당 입장 객수가 초과되었습니다.');
      // alert("회차당 입장수를 초과하였습니다.");
    } else if (intReturn === -3) {
      /*예매 시작전 또는 예매 종료 */
      toast.error('예매가 시작전이거나 예매가 종료되었습니다.');
      // alert("예매가 시작전이거나 예매가 종료되었습니다.");
    } else if (intReturn === -5) {
      /*예매 시작전 또는 예매 종료 */
      toast.error('회차당 인당 최대 예매수 4장을 초과하였습니다.');
      // alert("예매가 시작전이거나 예매가 종료되었습니다.");
    }
  };

  const _makeOrderCode = () => {
    let date = new Date();
    let f = 'a';
    let m = 1;
    let arr =
      '0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z'.split(
        ','
      );
    let newarr = new Array(m);
    let tmp = '';
    let flag = false;
    for (let i = 0; i < m; i++) {
      tmp = '';
      flag = false;
      for (let j = 0; j < 7; j++) {
        tmp += arr[Math.floor(Math.random() * arr.length)];
      }
      for (let k = 0; k < i; k++) {
        if (newarr[k] == f + tmp) {
          flag = true;
          i--;
          break;
        }
      }
      if (!flag) newarr[i] = f + tmp;
    }
    let temp = moment(date).format('YYYYMMDDhhmmss');

    return temp + '_' + loginId.substring(0, 4) + '_' + newarr[0];
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  const _rdateChange = (value, event) => {
    setValue(value);
    _getTimetable(exhibitionInfo[0].exhibitionCode, value);
  };

  const _getTimetable = async (exhibitionCode, value) => {
    // const exhibitionCode = exhibitionInfo[0].exhibitionCode;
    const rdate = moment(value).format('YYYYMMDD');
    // console.log(exhibitionCode, rdate);
    const result = await axios.post(apiUrl + '/exhibitionTimetable', {
      exhibitionCode,
      rdate,
    });

    const intReturn = result.data[0].intReturn;
    const listData = result.data[0].listData;
    if (intReturn === 0) {
      setTimetable(listData);
    }
  };
  const _back = () => {
    history.push('/event/323');
  };

  useEffect(() => {
    if (loginId === null || loginId === undefined || loginId === '') {
      history.push('/login');
    } else {
      _getData();
    }
  }, []);

  console.log(state);

  if (exhibitionInfo.length <= 0) {
    return <div></div>;
  }

  console.log(
    new Date('2024-01-01').getDate(),
    new Date('2024-01-01').getMonth(),
    new Date('2024-01-01').getFullYear()
  );
  return (
    <>
      <div id="wrap">
        <a className="close" onClick={_back} style={{ cursor: 'pointer' }}></a>
        {/* <!-- 컨텐츠영역 --> */}
        <section className="container5 tiket1">
          {/* <!-- 왼쪽 컨텐츠 --> */}
          <div className="bx bx_left">
            {/* <!-- 모바일용  --> */}
            <h1>
              <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" />
            </h1>
            <div className="section_line">
              <div className="section sec_item sec_item2">
                <div className="item">
                  <div className="thumb">
                    <img src={exhibitionInfo[0].img} alt="" />
                  </div>
                  <ul>
                    <li>
                      <span className="tit">작품명</span>
                      <span className="txt">
                        {exhibitionInfo[0].exhibitionName}
                      </span>
                    </li>
                    <li>
                      <span className="tit">기간</span>
                      <span className="txt">
                        {moment(exhibitionInfo[0].startDate).format(
                          'YYYY.MM.DD'
                        )}{' '}
                        ~{' '}
                        {moment(exhibitionInfo[0].endDate)
                          .add(-1, 'day')
                          .format('YYYY.MM.DD')}
                      </span>
                    </li>
                    <li>
                      <span className="tit">장소</span>
                      <span className="txt">
                        {exhibitionInfo[0].exhibitionLocationName}
                      </span>
                    </li>
                    <li>
                      <span className="tit">등급</span>
                      <span className="txt">{exhibitionInfo[0].grade}</span>
                    </li>
                    <li>
                      <span className="tit">관람시간</span>
                      <span className="txt">{exhibitionInfo[0].playTime}</span>
                    </li>
                    <li>
                      <span className="tit">결제금액</span>
                      <span className="txt">
                        {CommaFormatted(exhibitionInfo[0].price)}원
                        {exhibitionInfo[0].early === 'Y'
                          ? ' (얼리버드)'
                          : ' (일반)'}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!-- //모바일용 --> */}
            <div className="section">
              <div className="reserve scroll">
                <div className="tab_section">
                  <ul className="tab">
                    <li className="on" data-tab="tabmenu1">
                      <a>
                        step 1.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 2.<span>시간 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 3.<span>매수 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>
                        step 4.<span>결제방식 선택</span>
                      </a>
                    </li>
                  </ul>
                  <div id="tabmenu1" className="tabcont on">
                    <div>
                      <Calendar
                        onChange={_rdateChange}
                        className="calClass"
                        onClickDay={_onDateClick}
                        value={value}
                        minDate={
                          new Date() > new Date(exhibitionInfo[0].startDate)
                            ? new Date()
                            : new Date(exhibitionInfo[0].startDate)
                        }
                        maxDate={
                          new Date(
                            moment(exhibitionInfo[0].endDate).add(-1, 'day')
                          )
                        }
                        formatDay={(locale, date) => moment(date).format('D')}
                        tileDisabled={({ date, view }) =>
                          date.getDate() === 1 &&
                          date.getMonth() === 0 &&
                          date.getFullYear() === 2024
                        }
                      />
                    </div>
                    <ul className="calendar_ty">
                      <li className="ty1">예매가능한 날짜</li>
                      <li className="ty2">선택하신 날짜</li>
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 1.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li className="on" data-tab="tabmenu2">
                      <a>
                        step 2.<span>시간 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 3.<span>매수 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>
                        step 4.<span>결제방식 선택</span>
                      </a>
                    </li>
                  </ul>
                  <div id="tabmenu2" className="tabcont">
                    <ul className="select">
                      {timetable.map((item, index) => (
                        <li
                          className={
                            state.rtime === item.rtime.toString() && 'active'
                          }
                          onClick={() =>
                            _selectTime(
                              item.rtime,
                              item.remainNum,
                              item.rtimeName
                            )
                          }
                        >
                          {item.remainNum <= 0 ? (
                            <span>{item.rtimeName}</span>
                          ) : (
                            <a href="#">
                              {item.rtimeName}
                              {item.remainNum < 10 &&
                                ' (' + item.remainNum + '장 남음)'}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 1.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 2.<span>시간 선택</span>
                      </a>
                    </li>
                    <li className="on" data-tab="tabmenu3">
                      <a>
                        step 3.<span>매수 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu4">
                      <a>
                        step 4.<span>결제방식 선택</span>
                      </a>
                    </li>
                  </ul>
                  <div id="tabmenu3" className="tabcont">
                    <p className="refer">※ 한 회당 최대 4매까지 선택 가능</p>
                    <ul className="select select_cnt">
                      <li className={state.rcount === 1 && 'active'}>
                        {state.remainNum >= 1 ? (
                          <a href="#" onClick={() => _selectNum(1)}>
                            1매
                          </a>
                        ) : (
                          <span>1매</span>
                        )}
                      </li>
                      <li className={state.rcount === 2 && 'active'}>
                        {state.remainNum >= 2 ? (
                          <a href="#" onClick={() => _selectNum(2)}>
                            2매
                          </a>
                        ) : (
                          <span>2매</span>
                        )}
                      </li>
                      <li className={state.rcount === 3 && 'active'}>
                        {state.remainNum >= 3 ? (
                          <a href="#" onClick={() => _selectNum(3)}>
                            3매
                          </a>
                        ) : (
                          <span>3매</span>
                        )}
                      </li>
                      <li className={state.rcount === 4 && 'active'}>
                        {state.remainNum >= 4 ? (
                          <a href="#" onClick={() => _selectNum(4)}>
                            4매
                          </a>
                        ) : (
                          <span>4매</span>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="tab_section">
                  <ul className="tab">
                    <li data-tab="tabmenu1">
                      <a>
                        step 1.<span>날짜 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu2">
                      <a>
                        step 2.<span>시간 선택</span>
                      </a>
                    </li>
                    <li data-tab="tabmenu3">
                      <a>
                        step 3.<span>매수 선택</span>
                      </a>
                    </li>
                    <li className="on" data-tab="tabmenu4">
                      <a>
                        step 4.<span>결제방식 선택</span>
                      </a>
                    </li>
                  </ul>
                  <div id="tabmenu4" className="tabcont">
                    <ul className="select">
                      <li className={state.payType === '카드' && 'active'}>
                        <a href="#" onClick={() => _selectPay('카드')}>
                          신용카드
                        </a>
                      </li>
                      <li className={state.payType === '계좌이체' && 'active'}>
                        <a href="#" onClick={() => _selectPay('계좌이체')}>
                          계좌이체
                        </a>
                      </li>
                      <li
                        className={state.payType === '네이버페이' && 'active'}
                      >
                        <a href="#" onClick={() => _selectPay('네이버페이')}>
                          네이버 페이
                        </a>
                      </li>
                      <li
                        className={state.payType === '카카오페이' && 'active'}
                      >
                        <a href="#" onClick={() => _selectPay('카카오페이')}>
                          카카오 페이
                        </a>
                      </li>
                      <li className={state.payType === '토스페이' && 'active'}>
                        <a href="#" onClick={() => _selectPay('토스페이')}>
                          토스 페이
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="noti">
                  <div className="noti_tit">유의사항</div>
                  <ol>
                    <li>
                      1.관람하실 일자와 해당 일자 내 관람하실 시간대까지
                      지정하시어 예매하셔야 하며, 예매하신 일자와 회차에 맞게
                      입장 및 퇴장이 진행됩니다
                    </li>
                    <li>
                      2. 티켓 구매에 대한 취소 및 환불은 예매하신 일자의 2일
                      전까지만 가능하며 이후에는 취소가 절대 불가능하오니 신중한
                      예매를 부탁 드립니다.
                    </li>
                    <li>
                      3. 전시장 내부가 어둡고, 사운드의 음량이 커 폐소 공포증이
                      있거나, 유아, 어린이, 임산부, 노약자 등에 해당하는 분들은
                      예매 및 입장에 유의 부탁 드립니다.
                    </li>
                    <li>
                      4. 한 예매 건에 대한 부분 발권은 불가합니다. 같은 일자로
                      한 번에 관람하실 예정이 아니신 경우, 개별 건으로 예매 부탁
                      드립니다.
                    </li>
                    <li>
                      5. 예매 회차 변경 시에는 예매 취소 후, 재예매를 부탁
                      드립니다.
                    </li>
                    <li>
                      6.예매자는 본 예매 상세페이지의 모든 내용을 숙지 및 동의한
                      것으로 간주합니다. (안내 미숙지로 인한 책임은 예매자
                      본인에게 있으며, 이로 인한 취소, 변경, 환불은 불가합니다.)
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 오른쪽 컨텐츠 --> */}
          <div className="col bx_right">
            <div
              className="bx bx1"
              style={
                isMobile
                  ? {
                      position: 'fixed',
                      bottom: 0,
                      width: '100%',
                      backgroundColor: '#fff',
                    }
                  : {}
              }
            >
              {/* <!-- 웹용 --> */}
              <h1>
                <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" />
              </h1>
              <div className="section sec_item sec_item2">
                <div className="item">
                  <div className="thumb">
                    <img src={exhibitionInfo[0].img} alt="" />
                  </div>
                  <ul>
                    <li>
                      <span className="tit">작품명</span>
                      <span className="txt">
                        {exhibitionInfo[0].exhibitionName}
                      </span>
                    </li>
                    <li>
                      <span className="tit">기간</span>
                      <span className="txt">
                        {moment(exhibitionInfo[0].startDate).format(
                          'YYYY.MM.DD'
                        )}{' '}
                        ~{' '}
                        {moment(exhibitionInfo[0].endDate)
                          .add(-1, 'day')
                          .format('YYYY.MM.DD')}
                      </span>
                    </li>
                    <li>
                      <span className="tit">장소</span>
                      <span className="txt">
                        {exhibitionInfo[0].exhibitionLocationName}
                      </span>
                    </li>
                    <li>
                      <span className="tit">등급</span>
                      <span className="txt">{exhibitionInfo[0].grade}</span>
                    </li>
                    <li>
                      <span className="tit">관람시간</span>
                      <span className="txt">{exhibitionInfo[0].playTime}</span>
                    </li>
                    <li>
                      <span className="tit">결제금액</span>
                      <span className="txt">
                        {CommaFormatted(exhibitionInfo[0].price)}원
                        {exhibitionInfo[0].early === 'Y'
                          ? ' (얼리버드)'
                          : ' (일반)'}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <!-- //웹용 --> */}
              <div className="section_fot">
                <div className="totalinfo">
                  <dl>
                    <dt>날짜</dt>
                    <dd>
                      {' '}
                      {state.rdate === '0'
                        ? ''
                        : moment(
                            state.rdate.substring(0, 4) +
                              '-' +
                              state.rdate.substring(4, 6) +
                              '-' +
                              state.rdate.substring(6, 8)
                          ).format('YYYY.MM.DD(dd)')}
                    </dd>
                  </dl>
                  <dl>
                    <dt>시간</dt>
                    <dd>{state.rtime === '0' ? '' : state.rtimeName}</dd>
                  </dl>
                  <dl>
                    <dt>수량</dt>
                    <dd>{state.rcount}매</dd>
                  </dl>
                </div>
                <div className="totalprice">
                  <dl>
                    <dt>최종 결제금액</dt>
                    <dd>
                      {CommaFormatted(state.rcount * exhibitionInfo[0].price)}원
                    </dd>
                  </dl>
                </div>

                <div className="btn_area">
                  <a onClick={_apply} style={{ cursor: 'pointer' }}>
                    예매하기
                  </a>
                </div>
              </div>
            </div>
            <div className="bx bx2">
              <div className="totalinfo">
                <dl>
                  <dt>날짜</dt>
                  <dd>
                    {' '}
                    {state.rdate === '0'
                      ? ''
                      : moment(
                          state.rdate.substring(0, 4) +
                            '-' +
                            state.rdate.substring(4, 6) +
                            '-' +
                            state.rdate.substring(6, 8)
                        ).format('YYYY.MM.DD(dd)')}
                  </dd>
                </dl>
                <dl>
                  <dt>시간</dt>
                  <dd>{state.rtime === '0' ? '' : state.rtimeName}</dd>
                </dl>
                <dl>
                  <dt>수량</dt>
                  <dd>{state.rcount}매</dd>
                </dl>
              </div>
              <div className="totalprice">
                <dl>
                  <dt>최종 결제금액</dt>
                  <dd>
                    {CommaFormatted(state.rcount * exhibitionInfo[0].price)}원
                  </dd>
                </dl>
              </div>
              <div className="btn_area">
                <a onClick={_apply} style={{ cursor: 'pointer' }}>
                  예매하기
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="content">
        <div style={{ backgroundColor: "#fff" }}>
          <div>전시명: {exhibitionInfo[0].exhibitionName}</div>
          <div>기간: </div>
          <div>장소: </div>
          <div>등급: </div>
          <div>관람시간: </div>
          <div>가격: {exhibitionInfo[0].price}</div>
          <div>{exhibitionInfo[0].early === "Y" ? "얼리버드" : "일반"}</div>
        </div>
        <div style={{ backgroundColor: "#fff" }}>
          <Calendar
            onChange={_rdateChange}
            className="calClass"
            onClickDay={_onDateClick}
            value={value}
            minDate={
              new Date() > new Date(exhibitionInfo[0].startDate)
                ? new Date()
                : new Date(exhibitionInfo[0].startDate)
            }
            maxDate={new Date(moment(exhibitionInfo[0].endDate).add(-1, "day"))}
            formatDay={(locale, date) => moment(date).format("D")}
          />
        </div>
        <div style={{ marginTop: 20, backgroundColor: "#fff" }}>
          {timetable.map((item, index) => (
            <div
              value={item.rtime}
              onClick={() =>
                _selectTime(item.rtime, item.remainNum, item.rtimeName)
              }
              style={{
                color:
                  state.rtime === item.rtime.toString()
                    ? "red"
                    : item.remainNum <= 0
                    ? "gray"
                    : "blue",
              }}
            >
              {item.rtimeName}({item.remainNum})
            </div>
          ))}
        </div>
        <div style={{ marginTop: 20, backgroundColor: "#fff" }}>
          <div
            style={{
              color:
                state.rcount === 1
                  ? "red"
                  : state.remainNum >= 1
                  ? "blue"
                  : "gray",
            }}
            onClick={() => _selectNum(1)}
          >
            1매
          </div>
          <div
            style={{
              color:
                state.rcount === 2
                  ? "red"
                  : state.remainNum >= 1
                  ? "blue"
                  : "gray",
              backgroundColor: "#fff",
            }}
            onClick={() => _selectNum(2)}
          >
            2매
          </div>
          <div
            style={{
              color:
                state.rcount === 3
                  ? "red"
                  : state.remainNum >= 1
                  ? "blue"
                  : "gray",
              backgroundColor: "#fff",
            }}
            onClick={() => _selectNum(3)}
          >
            3매
          </div>
          <div
            style={{
              color:
                state.rcount === 4
                  ? "red"
                  : state.remainNum >= 1
                  ? "blue"
                  : "gray",
              backgroundColor: "#fff",
            }}
            onClick={() => _selectNum(4)}
          >
            4매
          </div>
        </div>
        <div style={{ marginTop: 20, backgroundColor: "#fff" }}>
          <div
            onClick={() => _selectPay("카드")}
            style={{ color: state.payType === "카드" ? "red" : "blue" }}
          >
            신용카드
          </div>
          <div
            onClick={() => _selectPay("계좌이체")}
            style={{ color: state.payType === "계좌이체" ? "red" : "blue" }}
          >
            계좌이체
          </div>
          <div
            onClick={() => _selectPay("네이버페이")}
            style={{ color: state.payType === "네이버페이" ? "red" : "blue" }}
          >
            네이버 페이
          </div>
          <div
            onClick={() => _selectPay("카카오페이")}
            style={{ color: state.payType === "카카오페이" ? "red" : "blue" }}
          >
            카카오 페이
          </div>
          <div
            onClick={() => _selectPay("토스페이")}
            style={{ color: state.payType === "토스페이" ? "red" : "blue" }}
          >
            토스 페이
          </div>
        </div>
        <div style={{ marginTop: 20, backgroundColor: "#fff" }}>
          <div style={{ backgroundColor: "#fff" }}>
            날짜:{" "}
            {state.rdate === "0"
              ? ""
              : moment(
                  state.rdate.substring(0, 4) +
                    "-" +
                    state.rdate.substring(4, 6) +
                    "-" +
                    state.rdate.substring(6, 8)
                ).format("YYYY.MM.DD(dd)")}
          </div>
          <div style={{ backgroundColor: "#fff" }}>
            시간: {state.rtime === "0" ? "" : state.rtimeName}
          </div>
          <div style={{ backgroundColor: "#fff" }}>수량: {state.rcount}</div>
          <div style={{ backgroundColor: "#fff" }}>
            결제금액: {CommaFormatted(state.rcount * exhibitionInfo[0].price)}
          </div>
          <div
            onClick={
              state.rdate === "0" ||
              state.rtime === "0" ||
              state.rlocation === "0" ||
              state.rcount === "0" ||
              state.payType === ""
                ? null
                : _apply
            }
            style={{
              color:
                state.rdate === "0" ||
                state.rtime === "0" ||
                state.rcount === "0" ||
                state.payType === ""
                  ? "gray"
                  : "red",
              backgroundColor: "#fff",
            }}
          >
            결제하기
          </div>
          <div style={{ height: 100, backgroundColor: "#fff" }}></div>
        </div>
      </div> */}
    </>
  );
};

export default shopContext(withRouter(Reserve));
